import type { ResponseType, User } from '@/types/common';
import { PermissionPageKey } from '@/types/permission';
import httpUtil from '@/utils/http';

const request = httpUtil.mfd.request;
const prefix = '/api/v1';

export const userApi = {
  /**
   * @description 获取当前用户信息
   */
  getCurrentUserInfo(): ResponseType<User> {
    return request({
      method: 'GET',
      url: `${prefix}/user`,
    });
  },

  /**
   * @description 获取当前用户的页面权限
   */
  getPagePermissions(): ResponseType<string[]> {
    return Promise.resolve({
      code: 0,
      data: Object.values(PermissionPageKey),
      msg: 'success',
    });
  },

  /**
   * @description 飞书账号注册（绑定流程已移除：登录按飞书身份自动匹配，找不到才注册）
   */
  feishuRegister(utoken: string, data: { role?: string }): ResponseType {
    return request({
      method: 'POST',
      url: prefix + `/user/feishuRegister`,
      headers: { utoken },
      data,
    });
  },

  /**
   * @description 获取所有用户信息，可选按 realName 搜索
   */
  getAllUser(params?: { realName?: string }): ResponseType<User[]> {
    return request({
      url: prefix + `/users`,
      params,
    });
  },

  /**
   * @description 更新当前用户信息
   */
  updateCurrentUserInfo(data: { realName?: string; email?: string; phone?: string; avatar?: string }): ResponseType {
    return request({
      method: 'PUT',
      url: prefix + `/user`,
      data,
    });
  },

  /**
   * @description 修改当前用户密码
   */
  updatePassword(data: { oldPwd?: string; newPwd: string; mfaToken?: string }): ResponseType {
    return request({
      method: 'POST',
      url: prefix + `/user/pwd`,
      data,
    });
  },
};
